"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.memoize"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = (0, _lodash.default)(function (user) {
  if (!user) {
    return '';
  }

  var desc = [user.officeLocation ? "Region: ".concat(user.officeLocation) : void 0, user.department ? "Branch: ".concat(user.department) : void 0].filter(Boolean);
  return desc.length ? desc : '';
});

exports.default = _default;